import React from 'react';
import classnames from 'classnames';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import PropTypes from 'prop-types';

import { Img } from 'utilities/components/img/component';

import './view.scss';

SwiperCore.use([Navigation]);

export const OptionsView = ({
    isInteractive,
    isLarge,
    property,
    data,
    additionalData,
    activeOption,
    activeAdditionalOption,
    setActiveOption,
    isSliderOnly,
    isAccessory
}) => {
    const handleSetActiveOption = (currentValue) => {
        setActiveOption({ [property]: { name: currentValue?.name, id: currentValue?.alternative_id }, ...(additionalData && { [Object?.keys(additionalData)[0]]: Object?.values(additionalData)[0] }) });
    };

    // applies to 'wykończenia', 'wykończenia-mobile' only
    const interactive = (
        <div className="options">
            {
                data?.map?.((currentValue, index) => (
                    <button
                        className={
                            classnames('options__option', {
                                'options__option--active': (((currentValue?.alternative_id) === activeOption) && (activeAdditionalOption ? (Object?.values(additionalData)[0] === activeAdditionalOption) : true)),
                                'options__option--large': isLarge
                            })
                        }
                        type="button"
                        key={ index }
                        onClick={ () => handleSetActiveOption(currentValue) }
                    >
                        {
                            (currentValue?.image && (currentValue?.show_color_type !== 'color'))
                                ? (<Img className="option__image" src={ `${process.env.GATSBY_URL}/${currentValue?.image}` } alt={ currentValue?.name } />)
                                : (<div className="option__color" style={{ backgroundColor: currentValue?.code }} />)
                        }
                        <span className="option__label">{ currentValue?.name }</span>
                    </button>
                ))
            }
        </div>
    );

    const sliderOptionsView = (
        <Swiper className={ classnames('slider', { 'slider--desktop': isSliderOnly }) } loop navigation>
            {
                data?.map?.((currentValue, index) => (
                    <SwiperSlide className="slider__option" key={ index }>
                        <Img className="option__image" src={ `${process.env.GATSBY_URL}/${currentValue?.image}` } alt={ currentValue?.name } />
                        <p className="option__name">{ currentValue?.name }</p>
                        {
                            isAccessory && currentValue?.price
                                ? (
                                    <p className="option__price">
                                        { currentValue?.price }
                                        { ' ' }
                                        ZŁ
                                    </p>

                                ) : null
                        }
                    </SwiperSlide>
                ))
            }
        </Swiper>
    );

    const desktopOptionsView = (
        <div className="options options--desktop">
            {
                data?.map?.((currentValue, index) => (
                    <div className="options__option" key={ index }>
                        <Img className="option__image" src={ `${process.env.GATSBY_URL}/${currentValue?.image}` } alt={ currentValue?.name } />
                        <p className="option__name">{ currentValue?.name }</p>
                        {
                            isAccessory && currentValue?.price
                                ? (
                                    <p className="option__price">
                                        { currentValue?.price }
                                        { ' ' }
                                        ZŁ
                                    </p>

                                ) : null
                        }
                    </div>
                ))
            }
        </div>
    );

    return (
        (isInteractive)
            ? interactive
            : (
                <>
                    { !isSliderOnly && desktopOptionsView }
                    { sliderOptionsView }
                </>
            )
    );
};

OptionsView.defaultProps = {
    isInteractive: false,
    isLarge: false,
    property: {},
    additionalData: null,
    activeOption: 0,
    activeAdditionalOption: '',
    setActiveOption: () => {},
    isSliderOnly: false,
    isAccessory: false
};

OptionsView.propTypes = {
    isInteractive: PropTypes.bool,
    isLarge: PropTypes.bool,
    property: PropTypes.string,
    data: PropTypes.instanceOf(Array).isRequired,
    additionalData: PropTypes.instanceOf(Object),
    activeOption: PropTypes.number,
    activeAdditionalOption: PropTypes.string,
    setActiveOption: PropTypes.func,
    isSliderOnly: PropTypes.bool,
    isAccessory: PropTypes.bool
};